module.exports = __webpack_public_path__ + "img/expand_pressed.a735e03d.svg";